import { render, staticRenderFns } from "./ClientDetail.vue?vue&type=template&id=36880c4e"
import script from "./ClientDetail.vue?vue&type=script&lang=ts"
export * from "./ClientDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports